<template>
  <div>
    <van-nav-bar left-text="消息通知" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <ul class="events_list">
      <li>
        <img :src="data.mainFileUrl">
      </li>
      <li class="title">{{ data.name }}
      </li>
      <li class="cent">{{ formatTime(data.moduleTime) }}
      </li>
      <li class="cent">{{ data.describe }}
      </li>
      <li v-if="data.fileUrl && JSON.parse(data.fileUrl).length > 0">
        <img v-for="(item, index) in JSON.parse(data.fileUrl)" :key="index" :src="item.url" class="file_img">
      </li>
    </ul>
  </div>
</template>
<script>
import { getNoticeDetail } from '@/api/index'
export default {
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    // 回获取路由参数
    this.getDetail();
  },
  methods: {
    onClickLeft() {
      this.$router.push({ path: '/message', query: { active: 2 } })
    },
    getDetail() {
      const { id } = this.$route.query;
      getNoticeDetail(id).then(res => {
        console.log(res);
        this.data = res
      })
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
}
</script>
<style lang="less" scoped>
.events_list {
  padding: 20px;

  .title {
    margin-top: 20px;
    font-size: 0.14rem;
    font-weight: bold;
    color: #333;
    // 文字溢出显示。。。
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .cent {
    margin: 10px 0;
    line-height: 20px;
  }

  img {
    width: 100%;
  }

  .file_img {
    margin-top: 10px;
  }
}
</style>